var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Upload.module.scss';
import { Loader } from 'src/ui/components/Loader/Loader';
import { useEffect, useState } from 'react';
export var Upload = function (props) {
    var soa3UploadUrl = props.soa3UploadUrl;
    var _a = useState(true), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(0), iframeHeight = _b[0], setIframeHeight = _b[1];
    // Can't use onLoad because CORS issue
    useEffect(function () {
        var handleIframeResize = function (e) {
            var data = e.data;
            var isResizeEvent = data && data.type === 'resizeUpload';
            if (isResizeEvent) {
                setIframeHeight(data.height);
            }
        };
        window.addEventListener('message', handleIframeResize);
        return function () {
            window.removeEventListener('message', handleIframeResize);
        };
    });
    var handleUploadLoading = function (e) {
        setIsLoading(false);
    };
    return (_jsxs("section", __assign({ className: styles.uploadWrapper }, { children: [_jsx("iframe", { title: 'uploadV3', className: styles.uploadWrapperIframe, src: soa3UploadUrl, onLoad: handleUploadLoading, height: iframeHeight }), isLoading && (_jsx("div", __assign({ className: styles.uploadLoaderWrapper }, { children: _jsx(Loader, { className: styles.uploadLoader }) })))] })));
};
